import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HostnameBuilderService } from './helpers/hostname-builder.service';
import { CookieHandlerService } from './helpers/cookie-handler.service';
import { LogService } from './log.service';
import { Subject, takeUntil } from 'rxjs';
import { CliffLogCodes } from '../shared/constants/cliff-log-constants';
import { RepairEligResponse } from '../models/repair.elig.response';
import { LoadingService } from './loading.service';
import { LossReportService } from './loss-report.service';

@Injectable({
  providedIn: 'root'
})
export class RepairEligibilityService {

  evaluationBegin = new Subject<any>();
  decisionReceived = new Subject<any>();
  isRepairEligible = false;
  role: string;
  participantId; string;
  isSimpleRepair: boolean;
  work_related : string;
  speciality_vehicle: string;
  DOL : string;
  repairEligibilityStartTime: number;
  repairEligibilityEndTime: number;
  repairEligibilityDuration: number;

  constructor(
    private http: HttpClient,
    private hostnameBuilder: HostnameBuilderService,
    private cookieService: CookieHandlerService,
    private logService: LogService,
    private loadingService: LoadingService,
    private lossReportService: LossReportService

  ) { }

  getRepairEligibility(extClaimId: string, extClientId: string): Subject<any> {
     this.repairEligibilityStartTime =performance.now()/1000;
    this.evaluationBegin.next(true);
    this.loadingService.startRequest();
    const url = `${this.hostnameBuilder.getRepairEligURL(extClaimId, extClientId)}`;
    const repairEligResponse = new RepairEligResponse;
     const dateOfLoss = this.lossReportService.getStepByName('dateOfLoss');
      const workRelated=this.lossReportService.getStepByName('usedForBusiness');
      const specialityVehicle=this.lossReportService.getStepByName('specialtyVehicle');

    let headers;
    const payload = {
       date_of_loss: Array.isArray(dateOfLoss?.question?.answers) ? dateOfLoss.question.answers[0] || '' : '',
  work_related: Array.isArray(workRelated?.question?.answers) ? workRelated.question.answers[0] || '' : '',
  speciality_vehicle: Array.isArray(specialityVehicle?.question?.answers) ? specialityVehicle.question.answers[0] || '' : ''
    };


    if (this.cookieService.getOauthToken()) {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'x-sf_sso_token': this.cookieService.getSSOToken(),
        'CorrelationId': this.logService.getCorrelationId(),
        'Authorization': this.cookieService.getOauthToken() ? 'Bearer ' + this.cookieService.getOauthToken() : ''
        });
    } else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'x-sf_sso_token': this.cookieService.getSSOToken(),
        'CorrelationId': this.logService.getCorrelationId()
        });
    }

    this.http
    .post(url, payload,{ headers: headers
    })
    .pipe(takeUntil(this.decisionReceived))
    .subscribe({
      next: response => {
        this.isRepairEligible = !!response['eligibility_decision'];
        this.role = response['role'];
        this.participantId = response['participant_id'];
        if( this. participantId != undefined || this.participantId != null || this.participantId != ''){
        this.repairEligibilityEndTime = performance.now()/1000;
        this.repairEligibilityDuration = this.repairEligibilityEndTime - this.repairEligibilityStartTime;
        this.logService.log(CliffLogCodes.REPAIR_ELIG_SUCCESS, {
      repairEligibilityDuration: this.repairEligibilityDuration,
      text: 'Success call duration'

    });
  }
        // @ts-ignore
        this.decisionReceived.next(response);
      },
      error: _error => {
        this.logService.log(CliffLogCodes.REPAIR_ELIG_FAIL);
        this.loadingService.completeRequest();
        this.decisionReceived.next(_error);
      }

    });
    return this.decisionReceived;
  }

  setIsRepairEligible(val) {
    this.isRepairEligible = val;
  }

  setRole(val) {
    this.role = val;
  }

  setParticipantId(val) {
    this.participantId = val;
  }

  getIsRepairEligible() {
    return this.isRepairEligible;
  }

  getIsSimpleRepair(): boolean{
    return this.isSimpleRepair;
  }

  getRole() {
    return this.role;
  }

  getParticipantId() {
    return this.participantId;
  }

  setSimpleRepair(value: boolean ):void{
      this.isSimpleRepair = value;
  }

}
